import { render, staticRenderFns } from "./clientLesson.vue?vue&type=template&id=e201be8e&"
import script from "./clientLesson.vue?vue&type=script&lang=js&"
export * from "./clientLesson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports